import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { InstructionsContainer } from "@/screens/Products/components/Product/Instructions/InstructionsContainer"

export const Route: AnyRoute = createFileRoute("/app/product/$productId/edit/_layout/instructions")({
  component: InstructionsContainer,
})
